/**
 * French labels for user role values.
 * Keys are the raw `user_type` values returned by the API
 * (USER_ARTIST_DJ="dj", USER_ARTIST_MUSICIAN="artist_musician",
 *  USER_AUDITOR_PRO="professional_auditor"). Legacy keys kept as fallback.
 */
export const ROLE_LABELS = {
    'dj': 'DJ',
    'artist_dj': 'DJ',
    'artist_musician': 'Musicien',
    'professional_auditor': 'Auditeur Pro'
};

/**
 * Color scheme for each user role (background, text, border).
 */
export const ROLE_COLORS = {
    'dj': { bg: "rgba(156, 39, 176, 0.12)", color: "#9C27B0", border: "rgba(156, 39, 176, 0.35)" },
    'artist_dj': { bg: "rgba(156, 39, 176, 0.12)", color: "#9C27B0", border: "rgba(156, 39, 176, 0.35)" },
    'artist_musician': { bg: "rgba(1, 181, 116, 0.12)", color: "#01885A", border: "rgba(1, 181, 116, 0.35)" },
    'professional_auditor': { bg: "rgba(57, 101, 255, 0.12)", color: "#3965FF", border: "rgba(57, 101, 255, 0.35)" }
};

/**
 * Default color scheme for unknown roles (light theme friendly).
 */
export const DEFAULT_ROLE_COLOR = {
    bg: "rgba(112, 126, 174, 0.12)",
    color: "#707EAE",
    border: "rgba(112, 126, 174, 0.30)"
};

/**
 * Classifies a role value into one of three buckets used by the role tabs.
 * Accepts API values with or without the "user_" prefix. DJs ("dj") and
 * musicians ("artist_musician") are artists; "professional_auditor" is auditor.
 * @param {string} role - Role value as returned by the API (user_type)
 * @returns {"artist" | "auditor" | "other"}
 */
export function classifyRole(role) {
    if (!role) return "other";
    const normalized = role.replace(/^user_/, "");
    if (normalized === "professional_auditor" || normalized === "auditor_pro") return "auditor";
    if (normalized === "dj" || normalized.startsWith("artist_") || normalized === "musician") return "artist";
    return "other";
}

/**
 * Maps a role tab value to the lightweight backend search endpoint.
 * Each endpoint returns up to 10 light rows {id, name, email}; an empty
 * term browses the first matches. The endpoint itself scopes the role.
 */
export const ROLE_ENDPOINTS = {
    all: "/admin/users/search",
    artist: "/admin/users/search_artist",
    auditor: "/admin/users/search_auditor",
};

/**
 * Role tab option list shared between UsersRoleTabs and the browse hook.
 * `value` matches the values produced by classifyRole(), plus "all".
 */
export const ROLE_TAB_OPTIONS = [
    { value: "all", label: "Tous" },
    { value: "artist", label: "Artistes" },
    { value: "auditor", label: "Auditeurs Pro" },
    { value: "groups", label: "Groupes" },
];

/**
 * Default role tag shown on a list row for a given role tab, used when the
 * lightweight list rows carry no per-row role (the endpoint scopes the role).
 */
export const TAB_ROLE_TAG = {
    artist: { label: "Artiste", ...ROLE_COLORS.dj },
    auditor: { label: "Auditeur Pro", ...ROLE_COLORS.professional_auditor },
};
